import { AxiosMethods, BannerNotificationsApi } from '@setvi/shared/enums';
import { axiosHelper } from '@setvi/shared/services';

import type { BannerNotification } from 'componentsV2/feature-banner';

export enum BannerNotificationsQueryKey {
  BANNER_NOTIFICATIONS = 'banner_notifications'
}

// Always scope to the web-app surface so we don't pull banners
// targeted at other surfaces (Outlook add-in, HubSpot card, iPhone).
const WEB_APP_MODULE = 'web-app';

export const bannerNotificationsQuery = () => ({
  queryKey: [BannerNotificationsQueryKey.BANNER_NOTIFICATIONS, WEB_APP_MODULE],
  queryFn: (): Promise<BannerNotification[]> =>
    axiosHelper({
      endpoint: BannerNotificationsApi.Get,
      method: AxiosMethods.GET,
      params: { module: WEB_APP_MODULE },
      baseURL: process.env.REVOPS_API
    }),
  // Endpoint returns a bare array; server already filters + sorts by priority.
  select: (res: BannerNotification[]) => res ?? []
});
